import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-management-dialog',
  templateUrl: './management-dialog.component.html',
  styleUrls: ['./management-dialog.component.scss']
})
export class ManagementDialogComponent implements OnInit {
  mode: number;
  title: string;
  role: any;
  actionsColumnsToDisplay = [];
  isActionsLoading: boolean;
  tableHeight: number;
  actions: MatTableDataSource<any> = new MatTableDataSource<any>();


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private commonService: CommonService,
              public toastMessagesService: ToastMessagesService, public dialogRef: MatDialogRef<ManagementDialogComponent>) {
    this.role = data.role;
    this.mode = data.mode;
    this.title = this.mode === 0 ? 'Διαχείριση Δικαιωμάτων Ενεργειών' : 'Διαχείριση Δικαιωμάτων Πλοήγησης';
    this.isActionsLoading = false;
    this.actionsColumnsToDisplay = this.mode === 0 ? ['select', 'description'] : ['select', 'title'];
    this.tableHeight = window.innerHeight - 272;

  }

  async ngOnInit() {
    if (this.mode === 0) {
      await this.initActions();
      await this.updateCheckedActions();
    }

    if (this.mode === 1) {
      await this.initNavigationItems();
      await this.updateCheckedActions();
    }
  }

  async updateCheckedActions() {
    try {
      console.log(this.role.id);
      const appliedActionsRequest = this.mode === 0 ? await this.commonService.getList(`roles/actions?roleId=${this.role.id}`) :
        await this.commonService.getList(`navigation/roles?roleId=${this.role.id}`) ;
      const actions = this.actions.data;

      if (appliedActionsRequest.object.length > 0) {

        for (const appliedAction of appliedActionsRequest.object) {
          const action = this.mode === 0 ? actions.find(a => a.id === appliedAction.action_id) :
            actions.find(a => a.id === appliedAction.navigation_path_id);
          if (action) {
            action.checked = true;
          }
        }
      }
    } catch (e) {
      console.log(e.message);
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initActions() {
    this.isActionsLoading = true;

    try {
      const actionsRequest = await this.commonService.getList(`actions`);
      for (const action of actionsRequest.object) {
        action.checked = false;
      }
      this.actions.data = actionsRequest.object;
    } catch (e) {
      console.log(e.message);
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isActionsLoading = false;
    }
  }

  async initNavigationItems() {
    this.isActionsLoading = true;

    try {
      const actionsRequest = await this.commonService.getList(`navigation/all`);
      for (const action of actionsRequest.object) {
        action.checked = false;
      }
      this.actions.data = actionsRequest.object;
    } catch (e) {
      console.log(e.message);
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isActionsLoading = false;
    }
  }


  actionSelected(action: any, event: any) {
    action.checked = event.checked;
  }

  async updateActions() {
    try {
      const selectedRole = this.role;
      const appliedActions = this.actions.data.filter(action => action.checked);
      const updateModel = {
        roleId: selectedRole.id,
        actions: appliedActions
      };

      this.mode === 0 ? await this.commonService.updateItem('roles/actions', updateModel) :
        await this.commonService.updateItem('navigation/paths', updateModel)  ;
      this.toastMessagesService.toastMessages(`Η ενημέρωση του ρόλου ${selectedRole.role_name} ολοκληρώθηκε με επιτυχία.`);
      this.dialogRef.close();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
